<div class="lm-container">

  <!-- Close -->
  <button class="lm-close" type="button" (click)="activeModal.dismiss()">
    <i class="fa-solid fa-xmark"></i>
  </button>

  <!-- Icon -->
  <div class="lm-icon">
    <i class="fa-solid fa-lock"></i>
  </div>

  <!-- Content -->
  <h2 class="lm-title" translate>Niveau verrouillé</h2>
  <p class="lm-subtitle" translate>
    Ce niveau n'est pas encore accessible.
  </p>

  <!-- Steps -->
  <div class="lm-steps">
    <div class="lm-step">
      <div class="lm-step-num">1</div>
      <p class="lm-step-text" translate>
        Complétez chaque jeu du niveau précédent
      </p>
    </div>
    <div class="lm-step-arrow">
      <i class="fa-solid fa-arrow-down"></i>
    </div>
    <div class="lm-step">
      <div class="lm-step-num lm-step-num--gold">
        <i class="fa-solid fa-star"></i>
      </div>
      <p class="lm-step-text" translate>
        Obtenez au moins <strong>80 %</strong> sur chacun d'eux
      </p>
    </div>
    <div class="lm-step-arrow">
      <i class="fa-solid fa-arrow-down"></i>
    </div>
    <div class="lm-step">
      <div class="lm-step-num lm-step-num--blue">
        <i class="fa-solid fa-unlock"></i>
      </div>
      <p class="lm-step-text" translate>
        Ce niveau se déverrouille automatiquement
      </p>
    </div>
  </div>

  <!-- Action -->
  <button class="lm-btn-ok" type="button" (click)="activeModal.dismiss()" translate>
    J'ai compris
  </button>

</div>
